import React from "react";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import { HowToRegRounded, InfoOutlined } from "@mui/icons-material";
import { BaseModal } from "./BaseModal";
import { PatientSummaryCard } from "./PatientSummaryCard";

// Modal de confirmación para reactivar (dar de alta nuevamente) a un socio
// que está inactivo. Header azul (acción positiva / restaurar).
export const ReactivatePatientModal = ({
  open,
  setOpen,
  handleConfirm,
  patient,
}) => {
  return (
    <BaseModal width="600px" open={open} setOpen={setOpen}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
        {/* Header de acción (azul de marca) */}
        <Box
          sx={{
            background: "linear-gradient(195deg, #002C54, #003f77)",
            borderRadius: "15px",
            color: "white",
            padding: "1.25rem 1.5rem",
            boxShadow: "0 8px 24px rgba(0,44,84,0.25)",
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              background: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <HowToRegRounded />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
              Dar de alta nuevamente
            </Typography>
            <Typography sx={{ fontSize: "13px", opacity: 0.85 }}>
              Confirmá la reactivación del socio
            </Typography>
          </Box>
        </Box>

        <PatientSummaryCard patient={patient} />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.6rem",
            background: "rgba(0,44,84,0.05)",
            border: "1px solid rgba(0,44,84,0.12)",
            borderRadius: "12px",
            padding: "0.75rem 1rem",
          }}
        >
          <InfoOutlined sx={{ color: "#002C54" }} />
          <Typography sx={{ fontSize: "13px", color: "#33485f" }}>
            El socio volverá a quedar activo y recuperará el acceso al servicio.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.75rem",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              paddingX: "1.5rem",
              color: "#5a6470",
              borderColor: "#d4d8dd",
              "&:hover": { borderColor: "#b9bfc6", background: "#f5f6f8" },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            startIcon={<HowToRegRounded />}
            onClick={() => handleConfirm(patient)}
            sx={{
              backgroundColor: "#002C54",
              borderRadius: "20px",
              textTransform: "none",
              paddingX: "1.5rem",
              boxShadow: "0 8px 20px rgba(0,44,84,0.28)",
              "&:hover": { backgroundColor: "#003F77" },
            }}
          >
            Confirmar alta
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};
